import { HiDocumentReport } from 'react-icons/hi';
import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';

export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];
const tiles = [
  {
    sNo: 1,
    isLink: false,
    link: '/common/skillEvaluationCategoryList',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'ADD SKILL',
    span: 'EVALUATION CATEGORY',
    isIcon: true,
  },
  {
    sNo: 2,
    isLink: false,
    link: '/common/skillMatrixList',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'SKILL',
    span: 'MATRIX',
    isIcon: true,
  },
];

const TNITiles = () => {
  return (
    <>
      <ChildHeader text="SKILL EVALUATION" />
      <RenderTiles tilesObj={tiles} height={'100vh'} justify="start" />
    </>
  );
};

export default TNITiles;
